import groq from 'groq';

export const OVERLINE = groq`
  "overline": {
    "type": coalesce(overline.type, "none"),
    "text": overline.text,
  }
`;
